// extracted by mini-css-extract-plugin
export default {"imageContainer":"G1-z","summaryPar":"H1-z","ratingCategories":"I1-z","reviewerInfo":"J1-z","reviewTypes":"K1-z","expanded":"L1-z"};